export const formatReports = (data) => {
  return data?.map?.((item) => {
    return {
      Id: item?.id,
      Name: item?.name,
      Category: item?.category?.name,
    };
  });
};
